import styled from 'styled-components';
import LogoSvg from '../assets/Logo';

const Logo = styled(LogoSvg)`
  height: 24px;
`;

export default Logo;
